/**
 * Thrown when an authenticated user does not belong to the organization that owns the
 * domain they entered on the sign-in screen.
 *
 * Golden Gate shared pool: one Cognito pool serves many org domains, so a valid credential
 * authenticates regardless of the entered domain — the cross-org check must happen
 * client-side against the caller's org set (from GetCurrentUser).
 */
export class CrossOrgSignInError extends Error {
    constructor (public readonly enteredDomain: string) {
        super(`User does not belong to the organization for domain "${enteredDomain}"`)
        this.name = 'CrossOrgSignInError'
    }
}
